export default [
  {id: 1, nome: 'Solteiro(a)'},
  {id: 2, nome: 'Casado(a)'},
  {id: 3, nome: 'Viúvo(a)'},
  {id: 4, nome: 'Separado(a)'},
  {id: 5, nome: 'Divorciado(a)'},
  {id: 6, nome: 'Amancebado(a)'}
]



// WEBPACK FOOTER //
// ./src/app/website/trabalhe-conosco/estados-civis.js